"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmThenRun = confirmThenRun;
var message_dialog_1 = require("../features/thunks/message-dialog");
var dialogs_1 = require("../interfaces/dialogs");
var api_error_message_1 = require("./api-error-message");
function confirmThenRun(options) {
    return __awaiter(this, void 0, void 0, function () {
        var dispatch, confirmHeader, confirmBody, confirmLabel, action, successHeader, successBody, failureHeader, failureBody, onStart, onSettled, _a, response, actionError_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch = options.dispatch, confirmHeader = options.confirmHeader, confirmBody = options.confirmBody, confirmLabel = options.confirmLabel, action = options.action, successHeader = options.successHeader, successBody = options.successBody, failureHeader = options.failureHeader, failureBody = options.failureBody, onStart = options.onStart, onSettled = options.onSettled;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch((0, message_dialog_1.showMessageDialogThunk)({
                            header: confirmHeader,
                            body: confirmBody,
                            buttons: [
                                { type: dialogs_1.EMessageDialogButtonType.CANCEL, label: "Cancel", variant: "secondary" },
                                { type: dialogs_1.EMessageDialogButtonType.OK, label: confirmLabel },
                            ],
                        })).unwrap()];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 4:
                    onStart === null || onStart === void 0 ? void 0 : onStart();
                    _b.label = 5;
                case 5:
                    _b.trys.push([5, 8, 10, 11]);
                    return [4 /*yield*/, action()];
                case 6:
                    response = _b.sent();
                    if (!response.success) {
                        throw new Error(response.message);
                    }
                    return [4 /*yield*/, dispatch((0, message_dialog_1.showMessageDialogThunk)({
                            header: successHeader,
                            body: successBody,
                            buttons: [{ type: dialogs_1.EMessageDialogButtonType.OK, label: "OK" }],
                        })).catch(function () { })];
                case 7:
                    _b.sent();
                    return [2 /*return*/, true];
                case 8:
                    actionError_1 = _b.sent();
                    return [4 /*yield*/, dispatch((0, message_dialog_1.showMessageDialogThunk)({
                            header: failureHeader,
                            body: (0, api_error_message_1.getApiErrorMessage)(actionError_1, failureBody),
                            buttons: [{ type: dialogs_1.EMessageDialogButtonType.OK, label: "OK" }],
                        })).catch(function () { })];
                case 9:
                    _b.sent();
                    return [2 /*return*/, false];
                case 10:
                    onSettled === null || onSettled === void 0 ? void 0 : onSettled();
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    });
}
